import React from 'react';
import PropTypes from 'prop-types';
import DOMPurify from 'dompurify';

const StaticCreateAccountErrorBox = props =>
  (
    <div className="alert alert-danger">
      <b>Error! </b>
      <span
        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(props.errorMessage) }}
      />
    </div>
  );

StaticCreateAccountErrorBox.propTypes = {
  errorMessage: PropTypes.string.isRequired,
};

export default StaticCreateAccountErrorBox;



// WEBPACK FOOTER //
// ./src-react/StaticRequestSignatureContentSection/components/StaticCreateAccountErrorBox.jsx